import { Component, OnInit } from '@angular/core';
import { HelpersService } from '@appNeo/neoCore/services/helpers/helpers.service';
import { EdicionSeccionesService } from '@appNeo/neoShared/modules/edicion-secciones/edicion-secciones.service';
import {RRSS} from '@appNeo/pages/fragmentos/menu-social/menu-social-edicion-data';

export interface IMenuSocialItem {
  titulo: string;
  url: string;
}

@Component({
  selector: 'neo-menu-social',
  templateUrl: './menu-social.component.html',
  styleUrls: ['./menu-social.component.scss'],
})
export class MenuSocialComponent implements OnInit {
  rrss: IMenuSocialItem [] = [];

  constructor(
    private helpersService: HelpersService,
    private edicionSeccionesService: EdicionSeccionesService,
  ) { 
    
  }
  ngOnInit(): void {
   this.iniciarPagina();
  }

  iniciarPagina() {
    if (this.helpersService.hayModulo('edicion')) {
      this.edicionSeccionesService.getContenidoBloquesSubseccion('contacto-rrss').subscribe(data => {
        data.elementos.forEach((elemento, index) => {
          let tituloRS = this.edicionSeccionesService.getCamposEdicionItem(elemento, `rrss-tit`, index);
          let urlRS = this.edicionSeccionesService.getCamposEdicionItem(elemento, `rrss-url`, index);
          this.rrss.push({
            titulo: tituloRS,
            url: urlRS
          });
        })
      })
    }
  }


}
